
$(() => {
    var date = (new Date()).getTimezoneOffset() * 60000;
    var localISOTime = (new Date(Date.now() - date)).toISOString().slice(0, 16);
    var elem = document.getElementById("Time");
    if (elem)
        elem.value = localISOTime;
});